// extracted by mini-css-extract-plugin
export var lg = "_32-4";
export var md = "_32-3";
export var sm = "_32-2";
export var xs = "_32-1";
export var xxs = "_32-0";